import { gql } from "@apollo/client";

const DeleteUserByTokenMutation = gql`
  mutation DeleteUserByTokenMutation(
    $token: ID!
    $feedback: InputFeedback
    $language: String
  ) {
    deleteUserByToken(token: $token, feedback: $feedback, language: $language)
  }
`;

export default DeleteUserByTokenMutation;
